import React, { useState, useEffect, useRef } from 'react'
import Slider, { Range } from 'rc-slider';

export default function PrivateDining({ updateSelection, filters }) {

  const [ minInputValue, setMinInputValue ] = useState(0)
  const [ maxInputValue, setMaxInputValue ] = useState(80)
  const [ isActive, setIsActive ] = useState(false)
  const [ isInitialized, setIsInitialized ] = useState(false)

  const marks = {
    0: '0',
    20: '',
    40: '',
    60: '',
    80: '80',
    100: '',
    120: '',
    140: '',
    160: '160',
  };

  
  const filter = () => {

      const filters = {
        filters: [
          {
            'field': 'private_dining_rooms.min_capacity',
            'condition': 'gt',
            'value': minInputValue,
          },
          {
            'field': 'private_dining_rooms.max_capacity',
            'condition': 'lt',
            'value': maxInputValue,
          }
        ]
      }
      updateSelection(
        filters,
        'replace'
      )

  }

  const onSliderChange = (values) => {
    setMinInputValue(values[0])
    setMaxInputValue(values[1])
  }

  useEffect(() => {
    setTimeout( () => {
      setIsActive(true)
      setIsInitialized(true)
    }, 1000)
  }, [])


  useEffect(() => {
    if ( !filters.value.length || isInitialized ) return
    if ( ( filters.value[0] !== minInputValue ) || ( filters.value[1] !== maxInputValue ) ) {

      setMinInputValue(filters.value[0])
      setMaxInputValue(filters.value[1])
    }
  })

  return (
    <div className={`c-searchSlider ${isActive ? 'is-active' : ''}`}>
      <div className="c-searchSlider__info mb-2">Party Size Required</div>
      <Range
        marks={marks}
        onChange={onSliderChange}
        onAfterChange={filter}
        max={160}
        value={[minInputValue, maxInputValue]}
      />
    </div>
  )
}


